export default __webpack_public_path__ + "static/media/login_background.cb557d26.jpg";